import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Input,
  Checkbox,
  IconButton,
  makeStyles
} from '@material-ui/core';

import EditIcon from "@material-ui/icons/EditOutlined";
import DoneIcon from "@material-ui/icons/DoneAllTwoTone";
import RevertIcon from "@material-ui/icons/NotInterestedOutlined";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import EditLocationIcon from "@material-ui/icons/EditLocationOutlined";

import { getDatabase, remove, set, ref as dbRef, onValue, push, child, update } from "firebase/database";
import { useDispatch } from 'react-redux';

import { setLoading } from '../../redux/actions';
import ConfirmActionModal from '../../components/confirm_action_modal';
import { NotificationManager } from '../../components/react-notifications';
import MapModal from '../../components/gmap';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2)
  },
  locationDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  editLocation: {
    marginLeft: theme.spacing(2)
  }
}));

const CustomTableCell = ({ row, name, onChange, showGMap }) => {
  const classes = useStyles();
  const { isEditMode } = row;

  const onEditLocation = () => {
    showGMap(row.id, row.address.location.latitude, row.address.location.longitude);
  };

  return (
    <TableCell align="left">
      {(name === 'address_latitude') && (row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['latitude'] === undefined ? 0 : row['address']['location']['latitude'])}

      {(name === 'address_longitude') && (isEditMode ? (
        <div className={classes.locationDiv}>
          {row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['longitude'] === undefined ? 0 : row['address']['location']['longitude']}
          <IconButton
            aria-label="done"
            className={classes.editLocation}
            onClick={() => onEditLocation()}
          >
            <EditLocationIcon />
          </IconButton>
        </div>
      ) : (
          row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['longitude'] === undefined ? 0 : row['address']['location']['longitude']
        ))}

      {(name === 'address_additionalAddressInfo') && (isEditMode ? (
        <Input
          value={row['address'] === undefined ? '' : row['address']['additionalAddressInfo'] === undefined ? '' : row['address']['additionalAddressInfo']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['address'] === undefined ? '' : row['address']['additionalAddressInfo'] === undefined ? '' : row['address']['additionalAddressInfo']
        ))}

      {(name === 'address_cityBasement') && (isEditMode ? (
        <Input
          value={row['address'] === undefined ? '' : row['address']['cityBasement'] === undefined ? '' : row['address']['cityBasement']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['address'] === undefined ? '' : row['address']['cityBasement'] === undefined ? '' : row['address']['cityBasement']
        ))}

      {(name === 'address_streetNoBasement') && (isEditMode ? (
        <Input
          value={row['address'] === undefined ? '' : row['address']['streetNoBasement'] === undefined ? '' : row['address']['streetNoBasement']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['address'] === undefined ? '' : row['address']['streetNoBasement'] === undefined ? '' : row['address']['streetNoBasement']
        ))}

      {(name === 'address_zipBasement') && (isEditMode ? (
        <Input
          value={row['address'] === undefined ? '' : row['address']['zipBasement'] === undefined ? '' : row['address']['zipBasement']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['address'] === undefined ? '' : row['address']['zipBasement'] === undefined ? '' : row['address']['zipBasement']
        ))}

      {name === 'basementStatus' && (isEditMode ? (
        <Checkbox
          name='basementStatus'
          checked={row[name] === undefined ? false : (row[name] === 1 ? true : false)}
          onChange={(event) => onChange(event, row)}
          value='true'
        />
      ) : (
          <Checkbox
            disabled
            checked={row[name] === undefined ? false : (row[name] === 1 ? true : false)}
          />
        ))}

      {(name === 'contactClique_email') && (isEditMode ? (
        <Input
          value={row['contactClique'] === undefined ? '' : row['contactClique']['email'] === undefined ? '' : row['contactClique']['email']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['contactClique'] === undefined ? '' : row['contactClique']['email'] === undefined ? '' : row['contactClique']['email']
        ))}

      {(name === 'contactClique_firstName') && (isEditMode ? (
        <Input
          value={row['contactClique'] === undefined ? '' : row['contactClique']['firstName'] === undefined ? '' : row['contactClique']['firstName']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['contactClique'] === undefined ? '' : row['contactClique']['firstName'] === undefined ? '' : row['contactClique']['firstName']
        ))}

      {(name === 'contactClique_function') && (isEditMode ? (
        <Input
          value={row['contactClique'] === undefined ? '' : row['contactClique']['function'] === undefined ? '' : row['contactClique']['function']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['contactClique'] === undefined ? '' : row['contactClique']['function'] === undefined ? '' : row['contactClique']['function']
        ))}

      {(name === 'contactClique_lastName') && (isEditMode ? (
        <Input
          value={row['contactClique'] === undefined ? '' : row['contactClique']['lastName'] === undefined ? '' : row['contactClique']['lastName']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['contactClique'] === undefined ? '' : row['contactClique']['lastName'] === undefined ? '' : row['contactClique']['lastName']
        ))}

      {(name === 'contactCliqueRep_email') && (isEditMode ? (
        <Input
          value={row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['email'] === undefined ? '' : row['contactCliqueRep']['email']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['email'] === undefined ? '' : row['contactCliqueRep']['email']
        ))}

      {(name === 'contactCliqueRep_firstName') && (isEditMode ? (
        <Input
          value={row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['firstName'] === undefined ? '' : row['contactCliqueRep']['firstName']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['firstName'] === undefined ? '' : row['contactCliqueRep']['firstName']
        ))}

      {(name === 'contactCliqueRep_function') && (isEditMode ? (
        <Input
          value={row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['function'] === undefined ? '' : row['contactCliqueRep']['function']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['function'] === undefined ? '' : row['contactCliqueRep']['function']
        ))}

      {(name === 'contactCliqueRep_lastName') && (isEditMode ? (
        <Input
          value={row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['lastName'] === undefined ? '' : row['contactCliqueRep']['lastName']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['lastName'] === undefined ? '' : row['contactCliqueRep']['lastName']
        ))}

      {name === 'doNotUse' && (isEditMode ? (
        <Checkbox
          name='doNotUse'
          checked={row[name] === undefined ? false : row[name]}
          onChange={(event) => onChange(event, row)}
          value='true'
        />
      ) : (
          <Checkbox
            disabled
            checked={row[name] === undefined ? false : row[name]}
          />
        ))}

      {name === 'notPublic' && (isEditMode ? (
        <Checkbox
          name='notPublic'
          checked={row[name] === undefined ? false : row[name]}
          onChange={(event) => onChange(event, row)}
          value='true'
        />
      ) : (
          <Checkbox
            disabled
            checked={row[name] === undefined ? false : row[name]}
          />
        ))}

      {name === 'openAtFasnacht' && (isEditMode ? (
        <Checkbox
          name='openAtFasnacht'
          checked={row[name] === undefined ? false : row[name]}
          onChange={(event) => onChange(event, row)}
          value='true'
        />
      ) : (
          <Checkbox
            disabled
            checked={row[name] === undefined ? false : row[name]}
          />
        ))}

      {name === 'openAtKaellerabstieg' && (isEditMode ? (
        <Checkbox
          name='openAtKaellerabstieg'
          checked={row[name] === undefined ? false : row[name]}
          onChange={(event) => onChange(event, row)}
          value='true'
        />
      ) : (
          <Checkbox
            disabled
            checked={row[name] === undefined ? false : row[name]}
          />
        ))}

      {(name === 'rentalInfo_contactEmail') && (isEditMode ? (
        <Input
          value={row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactEmail'] === undefined ? '' : row['rentalInfo']['contactEmail']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactEmail'] === undefined ? '' : row['rentalInfo']['contactEmail']
        ))}

      {(name === 'rentalInfo_contactFirstName') && (isEditMode ? (
        <Input
          value={row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactFirstName'] === undefined ? '' : row['rentalInfo']['contactFirstName']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactFirstName'] === undefined ? '' : row['rentalInfo']['contactFirstName']
        ))}

      {(name === 'rentalInfo_contactLastName') && (isEditMode ? (
        <Input
          value={row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactLastName'] === undefined ? '' : row['rentalInfo']['contactLastName']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactLastName'] === undefined ? '' : row['rentalInfo']['contactLastName']
        ))}

      {(name === 'rentalInfo_contactPhone') && (isEditMode ? (
        <Input
          value={row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactPhone'] === undefined ? '' : row['rentalInfo']['contactPhone']}
          name={name}
          onChange={e => onChange(e, row)}
          className={classes.input}
        />
      ) : (
          row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactPhone'] === undefined ? '' : row['rentalInfo']['contactPhone']
        ))}

      {name === 'rentalInfo_forRental' && (isEditMode ? (
        <Checkbox
          name='rentalInfo_forRental'
          checked={row['rentalInfo'] === undefined ? false : row['rentalInfo']['forRental'] === undefined ? false : row['rentalInfo']['forRental']}
          onChange={(event) => onChange(event, row)}
          value='true'
        />
      ) : (
          <Checkbox
            disabled
            checked={row['rentalInfo'] === undefined ? false : row['rentalInfo']['forRental'] === undefined ? false : row['rentalInfo']['forRental']}
          />
        ))}

      {(name !== 'address_additionalAddressInfo' &&
        name !== 'address_cityBasement' &&
        name !== 'address_latitude' &&
        name !== 'address_longitude' &&
        name !== 'address_streetNoBasement' &&
        name !== 'address_zipBasement' &&
        name !== 'contactClique_email' &&
        name !== 'contactClique_firstName' &&
        name !== 'contactClique_function' &&
        name !== 'contactClique_lastName' &&
        name !== 'contactCliqueRep_email' &&
        name !== 'contactCliqueRep_firstName' &&
        name !== 'contactCliqueRep_function' &&
        name !== 'contactCliqueRep_lastName' &&
        name !== 'rentalInfo_contactEmail' &&
        name !== 'rentalInfo_contactFirstName' &&
        name !== 'rentalInfo_contactLastName' &&
        name !== 'rentalInfo_contactPhone' &&
        name !== 'rentalInfo_forRental' &&
        name !== 'basementStatus' &&
        name !== 'doNotUse' &&
        name !== 'notPublic' &&
        name !== 'openAtFasnacht' &&
        name !== 'openAtKaellerabstieg') && (isEditMode ? (
          <Input
            value={row[name] === undefined ? '' : row[name]}
            name={name}
            onChange={e => onChange(e, row)}
            className={classes.input}
          />
        ) : (
            row[name]
          ))}
    </TableCell>
  );
};

const Results = ({ className, ...rest }, ref) => {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(0);
  const [previous, setPrevious] = useState({});
  const [isShowConfirm, toggleConfirm] = useState(false);
  const [delId, setDelId] = useState('');
  const [isShowMap, setIsShowMap] = useState(false);
  const [selId, setSelId] = useState('');
  const [curLat, setCurLat] = useState(0);
  const [curLon, setCurLon] = useState(0);
  const dispatch = useDispatch();

  const db = getDatabase();

  useEffect(() => {
    let arrTmp = [];

    dispatch(setLoading(true));

    navigator.geolocation.getCurrentPosition(function (position) {
      console.log(position);
      setCurLat(position.coords.latitude);
      setCurLon(position.coords.longitude);
    });

    return onValue(dbRef(db, '/maplocations/cliquekaeller'), (snapshot) => {
      snapshot.forEach(function (childSnapshot) {
        var childKey = childSnapshot.key;
        var childData = childSnapshot.val();
        childData['id'] = childKey;
        childData['isEditMode'] = false;

        arrTmp.push(childData);
      });
      setRows(arrTmp);

      dispatch(setLoading(false));

    }, {
      onlyOnce: true
    });
  }, [db, dispatch]);

  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious(state => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map(row => {
      if (row.id === id) {
        if (name === 'lat_lon') {
          return {
            ...row, address: {
              additionalAddressInfo: row['address'] === undefined ? '' : row['address']['additionalAddressInfo'] === undefined ? '' : row['address']['additionalAddressInfo'],
              cityBasement: row['address'] === undefined ? '' : row['address']['cityBasement'] === undefined ? '' : row['address']['cityBasement'],
              location: {
                latitude: e.target.lat,
                longitude: e.target.lon,
              },
              streetNoBasement: row['address'] === undefined ? '' : row['address']['streetNoBasement'] === undefined ? '' : row['address']['streetNoBasement'],
              zipBasement: row['address'] === undefined ? '' : row['address']['zipBasement'] === undefined ? '' : row['address']['zipBasement']
            }
          };
        } else if (name === 'address_additionalAddressInfo') {
          return {
            ...row, address: {
              additionalAddressInfo: value,
              cityBasement: row['address'] === undefined ? '' : row['address']['cityBasement'] === undefined ? '' : row['address']['cityBasement'],
              location: {
                latitude: row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['latitude'] === undefined ? 0 : row['address']['location']['latitude'],
                longitude: row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['longitude'] === undefined ? 0 : row['address']['location']['longitude'],
              },
              streetNoBasement: row['address'] === undefined ? '' : row['address']['streetNoBasement'] === undefined ? '' : row['address']['streetNoBasement'],
              zipBasement: row['address'] === undefined ? '' : row['address']['zipBasement'] === undefined ? '' : row['address']['zipBasement']
            }
          };
        } else if (name === 'address_cityBasement') {
          return {
            ...row, address: {
              additionalAddressInfo: row['address'] === undefined ? '' : row['address']['additionalAddressInfo'] === undefined ? '' : row['address']['additionalAddressInfo'],
              cityBasement: value,
              location: {
                latitude: row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['latitude'] === undefined ? 0 : row['address']['location']['latitude'],
                longitude: row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['longitude'] === undefined ? 0 : row['address']['location']['longitude'],
              },
              streetNoBasement: row['address'] === undefined ? '' : row['address']['streetNoBasement'] === undefined ? '' : row['address']['streetNoBasement'],
              zipBasement: row['address'] === undefined ? '' : row['address']['zipBasement'] === undefined ? '' : row['address']['zipBasement']
            }
          };
        } else if (name === 'address_streetNoBasement') {
          return {
            ...row, address: {
              additionalAddressInfo: row['address'] === undefined ? '' : row['address']['additionalAddressInfo'] === undefined ? '' : row['address']['additionalAddressInfo'],
              cityBasement: row['address'] === undefined ? '' : row['address']['cityBasement'] === undefined ? '' : row['address']['cityBasement'],
              location: {
                latitude: row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['latitude'] === undefined ? 0 : row['address']['location']['latitude'],
                longitude: row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['longitude'] === undefined ? 0 : row['address']['location']['longitude'],
              },
              streetNoBasement: value,
              zipBasement: row['address'] === undefined ? '' : row['address']['zipBasement'] === undefined ? '' : row['address']['zipBasement']
            }
          };
        } else if (name === 'address_zipBasement') {
          return {
            ...row, address: {
              additionalAddressInfo: row['address'] === undefined ? '' : row['address']['additionalAddressInfo'] === undefined ? '' : row['address']['additionalAddressInfo'],
              cityBasement: row['address'] === undefined ? '' : row['address']['cityBasement'] === undefined ? '' : row['address']['cityBasement'],
              location: {
                latitude: row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['latitude'] === undefined ? 0 : row['address']['location']['latitude'],
                longitude: row['address'] === undefined ? 0 : row['address']['location'] === undefined ? 0 : row['address']['location']['longitude'] === undefined ? 0 : row['address']['location']['longitude'],
              },
              streetNoBasement: row['address'] === undefined ? '' : row['address']['streetNoBasement'] === undefined ? '' : row['address']['streetNoBasement'],
              zipBasement: value
            }
          };
        } else if (name === 'basementStatus') {
          return { ...row, [name]: 1 - (isNaN(row[name]) ? 0 : row[name]) };
        } else if (name === 'contactClique_email') {
          return {
            ...row, contactClique: {
              email: value,
              firstName: row['contactClique'] === undefined ? '' : row['contactClique']['firstName'] === undefined ? '' : row['contactClique']['firstName'],
              function: row['contactClique'] === undefined ? '' : row['contactClique']['function'] === undefined ? '' : row['contactClique']['function'],
              lastName: row['contactClique'] === undefined ? '' : row['contactClique']['lastName'] === undefined ? '' : row['contactClique']['lastName']
            }
          };
        } else if (name === 'contactClique_firstName') {
          return {
            ...row, contactClique: {
              email: row['contactClique'] === undefined ? '' : row['contactClique']['email'] === undefined ? '' : row['contactClique']['email'],
              firstName: value,
              function: row['contactClique'] === undefined ? '' : row['contactClique']['function'] === undefined ? '' : row['contactClique']['function'],
              lastName: row['contactClique'] === undefined ? '' : row['contactClique']['lastName'] === undefined ? '' : row['contactClique']['lastName']
            }
          };
        } else if (name === 'contactClique_function') {
          return {
            ...row, contactClique: {
              email: row['contactClique'] === undefined ? '' : row['contactClique']['email'] === undefined ? '' : row['contactClique']['email'],
              firstName: row['contactClique'] === undefined ? '' : row['contactClique']['firstName'] === undefined ? '' : row['contactClique']['firstName'],
              function: value,
              lastName: row['contactClique'] === undefined ? '' : row['contactClique']['lastName'] === undefined ? '' : row['contactClique']['lastName']
            }
          };
        } else if (name === 'contactClique_lastName') {
          return {
            ...row, contactClique: {
              email: row['contactClique'] === undefined ? '' : row['contactClique']['email'] === undefined ? '' : row['contactClique']['email'],
              firstName: row['contactClique'] === undefined ? '' : row['contactClique']['firstName'] === undefined ? '' : row['contactClique']['firstName'],
              function: row['contactClique'] === undefined ? '' : row['contactClique']['function'] === undefined ? '' : row['contactClique']['function'],
              lastName: value
            }
          };
        } else if (name === 'contactCliqueRep_email') {
          return {
            ...row, contactCliqueRep: {
              email: value,
              firstName: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['firstName'] === undefined ? '' : row['contactCliqueRep']['firstName'],
              function: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['function'] === undefined ? '' : row['contactCliqueRep']['function'],
              lastName: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['lastName'] === undefined ? '' : row['contactCliqueRep']['lastName']
            }
          };
        } else if (name === 'contactCliqueRep_firstName') {
          return {
            ...row, contactCliqueRep: {
              email: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['email'] === undefined ? '' : row['contactCliqueRep']['email'],
              firstName: value,
              function: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['function'] === undefined ? '' : row['contactCliqueRep']['function'],
              lastName: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['lastName'] === undefined ? '' : row['contactCliqueRep']['lastName']
            }
          };
        } else if (name === 'contactCliqueRep_function') {
          return {
            ...row, contactCliqueRep: {
              email: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['email'] === undefined ? '' : row['contactCliqueRep']['email'],
              firstName: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['firstName'] === undefined ? '' : row['contactCliqueRep']['firstName'],
              function: value,
              lastName: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['lastName'] === undefined ? '' : row['contactCliqueRep']['lastName']
            }
          };
        } else if (name === 'contactCliqueRep_lastName') {
          return {
            ...row, contactCliqueRep: {
              email: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['email'] === undefined ? '' : row['contactCliqueRep']['email'],
              firstName: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['firstName'] === undefined ? '' : row['contactCliqueRep']['firstName'],
              function: row['contactCliqueRep'] === undefined ? '' : row['contactCliqueRep']['function'] === undefined ? '' : row['contactCliqueRep']['function'],
              lastName: value
            }
          };
        } else if (name === 'doNotUse') {
          return { ...row, [name]: row[name] !== undefined ? !row[name] : true };
        } else if (name === 'notPublic') {
          return { ...row, [name]: row[name] !== undefined ? !row[name] : true };
        } else if (name === 'openAtFasnacht') {
          return { ...row, [name]: row[name] !== undefined ? !row[name] : true };
        } else if (name === 'openAtKaellerabstieg') {
          return { ...row, [name]: row[name] !== undefined ? !row[name] : true };
        } else if (name === 'rentalInfo_contactEmail') {
          return {
            ...row, rentalInfo: {
              contactEmail: value,
              contactFirstName: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactFirstName'] === undefined ? '' : row['rentalInfo']['contactFirstName'],
              contactLastName: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactLastName'] === undefined ? '' : row['rentalInfo']['contactLastName'],
              contactPhone: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactPhone'] === undefined ? '' : row['rentalInfo']['contactPhone'],
              forRental: row['forRental'] === undefined ? false : row['rentalInfo']['forRental'] === undefined ? false : row['rentalInfo']['forRental']
            }
          };
        } else if (name === 'rentalInfo_contactFirstName') {
          return {
            ...row, rentalInfo: {
              contactEmail: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactEmail'] === undefined ? '' : row['rentalInfo']['contactEmail'],
              contactFirstName: value,
              contactLastName: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactLastName'] === undefined ? '' : row['rentalInfo']['contactLastName'],
              contactPhone: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactPhone'] === undefined ? '' : row['rentalInfo']['contactPhone'],
              forRental: row['forRental'] === undefined ? false : row['rentalInfo']['forRental'] === undefined ? false : row['rentalInfo']['forRental']
            }
          };
        } else if (name === 'rentalInfo_contactLastName') {
          return {
            ...row, rentalInfo: {
              contactEmail: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactEmail'] === undefined ? '' : row['rentalInfo']['contactEmail'],
              contactFirstName: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactFirstName'] === undefined ? '' : row['rentalInfo']['contactFirstName'],
              contactLastName: value,
              contactPhone: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactPhone'] === undefined ? '' : row['rentalInfo']['contactPhone'],
              forRental: row['forRental'] === undefined ? false : row['rentalInfo']['forRental'] === undefined ? false : row['rentalInfo']['forRental']
            }
          };
        } else if (name === 'rentalInfo_contactPhone') {
          return {
            ...row, rentalInfo: {
              contactEmail: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactEmail'] === undefined ? '' : row['rentalInfo']['contactEmail'],
              contactFirstName: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactFirstName'] === undefined ? '' : row['rentalInfo']['contactFirstName'],
              contactLastName: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactLastName'] === undefined ? '' : row['rentalInfo']['contactLastName'],
              contactPhone: value,
              forRental: row['forRental'] === undefined ? false : row['rentalInfo']['forRental'] === undefined ? false : row['rentalInfo']['forRental']
            }
          };
        } else if (name === 'rentalInfo_forRental') {
          return {
            ...row, rentalInfo: {
              contactEmail: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactEmail'] === undefined ? '' : row['rentalInfo']['contactEmail'],
              contactFirstName: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactFirstName'] === undefined ? '' : row['rentalInfo']['contactFirstName'],
              contactLastName: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactLastName'] === undefined ? '' : row['rentalInfo']['contactLastName'],
              contactPhone: row['rentalInfo'] === undefined ? '' : row['rentalInfo']['contactPhone'] === undefined ? '' : row['rentalInfo']['contactPhone'],
              forRental: row['rentalInfo'] === undefined ? false : row['rentalInfo']['forRental'] !== undefined ? !row['rentalInfo']['forRental'] : true
            }
          };
        } else {
          return { ...row, [name]: value };
        }
      }
      return row;
    });
    setRows(newRows);
  };

  const onToggleEditMode = id => {
    setRows(state => {
      return state.map(row => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const onSave = (id, row) => {
    dispatch(setLoading(true));

    set(dbRef(db, 'maplocations/cliquekaeller/' + id), row)
      .then(() => {
        // Data saved successfully!
        console.log("+++++++++ update success");
        setPrevious(state => {
          delete state[id];
          return state;
        });

        onToggleEditMode(id);

        dispatch(setLoading(false));

        NotificationManager.success(
          'Erfolgreich geändert',
          "Alert",
          3000,
          null,
          null,
          ''
        );
      })
      .catch((error) => {
        // The write failed...
        console.log("----------- update ", error);
        dispatch(setLoading(false));

        NotificationManager.warning(
          'Änderung fehlgeschlagen',
          "Alert",
          3000,
          null,
          null,
          ''
        );
      });
  };

  const onRevert = id => {
    const newRows = rows.map(row => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious(state => {
      delete state[id];
      return state;
    });
    onToggleEditMode(id);
  };

  const onRemoveClick = () => {
    onDelete(delId);
  };

  const onDelete = id => {
    dispatch(setLoading(true));

    remove(dbRef(db, 'maplocations/cliquekaeller/' + id))
      .then(() => {
        console.log("----------- delete success");
        const newRows = rows.filter(row => row.id !== id);
        setRows(newRows);
        dispatch(setLoading(false));

        NotificationManager.success(
          'Erfolgreich gelöscht',
          "Alert",
          3000,
          null,
          null,
          ''
        );
      })
      .catch(error => {
        console.log("------------ delete ", error);
        dispatch(setLoading(false));
        NotificationManager.warning(
          'Löschen fehlgeschlagen',
          "Alert",
          3000,
          null,
          null,
          ''
        );
      });
  }

  useImperativeHandle(ref, () => ({
    onAdd() {
      dispatch(setLoading(true));

      const db = getDatabase();
      // Get a key for a new Post.
      const newPostKey = push(child(dbRef(db), 'maplocations/cliquekaeller/')).key;

      const postData = {
        id: newPostKey,
        isEditMode: true,
        address: {
          location: {
            latitude: curLat,
            longitude: curLon
          }
        }
      };

      // Write the new post's data simultaneously in the posts list and the user's post list.
      const updates = {};
      updates['/maplocations/cliquekaeller/' + newPostKey] = postData;

      update(dbRef(db), updates)
        .then(() => {
          console.log("++++++++ add success");
          let newRows = rows.map(row => row);
          console.log(newRows);
          newRows.unshift(postData);
          console.log(newRows);
          setRows(newRows);
          setPage(0);

          dispatch(setLoading(false));

          NotificationManager.success(
            'Erfolgreich erstellt',
            "Alert",
            3000,
            null,
            null,
            ''
          );
        })
        .catch((error) => {
          console.log("+++++  add ", error);
          dispatch(setLoading(false));
          NotificationManager.warning(
            'Hinzufügen fehlgeschlagen',
            "Alert",
            3000,
            null,
            null,
            ''
          );
        });
    }
  }));

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const showGMap = (id, lat, lon) => {
    setSelId(id);
    setCurLat(lat);
    setCurLon(lon);

    setIsShowMap(true);
  };

  const changedPosition = (lat, lon) => {
    console.log("-----------", lat, lon)
    rows.forEach(row => {
      if (row.id === selId) {
        const e = { target: { name: 'lat_lon', value: lat, lat: lat, lon: lon } };
        onChange(e, row);
      }
    });
  };

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <ConfirmActionModal
        title="Löschen bestätigen"
        text="Möchtest du diesen Eintrag wirklich löschen"
        onConfirm={() => { onRemoveClick(); toggleConfirm(false); }}
        show={isShowConfirm}
        onClose={() => toggleConfirm(false)}
        confirmText="Löschen"
      />
      <MapModal
        isMarkerShown={true}
        curPos={{ lat: curLat, lon: curLon }}
        title="Position wählen"
        onConfirm={(lat, lon) => { changedPosition(lat, lon); setIsShowMap(false); }}
        show={isShowMap}
        onClose={() => setIsShowMap(false)}
        confirmText="Ok"
      />
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell rowSpan={3} align="left" />
                <TableCell colSpan={6} align="center">address</TableCell>
                <TableCell rowSpan={3}>admissionCriteria</TableCell>
                <TableCell rowSpan={3}>basementStatus</TableCell>
                <TableCell rowSpan={3}>capacity</TableCell>
                <TableCell colSpan={4} align="left">contactClique</TableCell>
                <TableCell colSpan={4} align="left">contactCliqueRep</TableCell>
                <TableCell rowSpan={3}>description</TableCell>
                <TableCell rowSpan={3}>doNotUse</TableCell>
                <TableCell rowSpan={3}>linkBasement</TableCell>
                <TableCell rowSpan={3}>linkClique</TableCell>
                <TableCell rowSpan={3}>logo</TableCell>
                <TableCell rowSpan={3}>nameBasement</TableCell>
                <TableCell rowSpan={3}>nameClique</TableCell>
                <TableCell rowSpan={3}>notPublic</TableCell>
                <TableCell rowSpan={3}>notes</TableCell>
                <TableCell rowSpan={3}>openAtFasnacht</TableCell>
                <TableCell rowSpan={3}>openAtKaellerabstieg</TableCell>
                <TableCell rowSpan={3}>openingHours</TableCell>
                <TableCell colSpan={5} align="center">rentalInfo</TableCell>
                <TableCell rowSpan={3}>speciality</TableCell>
              </TableRow>
              <TableRow>
                <TableCell rowSpan={2}>additionalAddressInfo</TableCell>
                <TableCell rowSpan={2}>cityBasement</TableCell>
                <TableCell colSpan={2} align="center">location</TableCell>
                <TableCell rowSpan={2}>streetNoBasement</TableCell>
                <TableCell rowSpan={2}>zipBasement</TableCell>
                <TableCell rowSpan={2}>email</TableCell>
                <TableCell rowSpan={2}>firstName</TableCell>
                <TableCell rowSpan={2}>function</TableCell>
                <TableCell rowSpan={2}>lastName</TableCell>
                <TableCell rowSpan={2}>email</TableCell>
                <TableCell rowSpan={2}>firstName</TableCell>
                <TableCell rowSpan={2}>function</TableCell>
                <TableCell rowSpan={2}>lastName</TableCell>
                <TableCell rowSpan={2}>contactEmail</TableCell>
                <TableCell rowSpan={2}>contactFirstName</TableCell>
                <TableCell rowSpan={2}>contactLastName</TableCell>
                <TableCell rowSpan={2}>contactPhone</TableCell>
                <TableCell rowSpan={2}>forRental</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>latitude</TableCell>
                <TableCell>longitude</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.slice(page * limit, (page + 1) * limit).map((row) => (
                <TableRow
                  hover
                  key={row.id}
                >
                  <TableCell className={classes.selectTableCell}>
                    {row.isEditMode ? (
                      <>
                        <IconButton
                          aria-label="done"
                          onClick={() => onSave(row.id, row)}
                        >
                          <DoneIcon />
                        </IconButton>
                        <IconButton
                          aria-label="revert"
                          onClick={() => onRevert(row.id)}
                        >
                          <RevertIcon />
                        </IconButton>
                      </>
                    ) : (
                        <>
                          <IconButton
                            aria-label="edit"
                            onClick={() => onToggleEditMode(row.id)}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            onClick={() => { toggleConfirm(true); setDelId(row.id); }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </>
                      )}
                  </TableCell>
                  <CustomTableCell {...{ row, name: "address_additionalAddressInfo", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "address_cityBasement", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "address_latitude", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "address_longitude", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "address_streetNoBasement", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "address_zipBasement", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "admissionCriteria", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "basementStatus", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "capacity", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "contactClique_email", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "contactClique_firstName", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "contactClique_function", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "contactClique_lastName", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "contactCliqueRep_email", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "contactCliqueRep_firstName", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "contactCliqueRep_function", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "contactCliqueRep_lastName", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "description", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "doNotUse", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "linkBasement", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "linkClique", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "logo", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "nameBasement", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "nameClique", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "notPublic", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "notes", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "openAtFasnacht", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "openAtKaellerabstieg", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "openingHours", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "rentalInfo_contactEmail", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "rentalInfo_contactFirstName", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "rentalInfo_contactLastName", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "rentalInfo_contactPhone", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "rentalInfo_forRental", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                  <CustomTableCell {...{ row, name: "speciality", onChange }} showGMap={(id, lat, lon) => showGMap(id, lat, lon)} />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={rows.length}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25, 100]}
      />
    </Card>
  );
};

export default forwardRef(Results);
